'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Reboot = require('./Reboot');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Reboot).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Reboot/index.js
// module id = 5601
// module chunks = 39